import React from 'react'
import style from './style.module.scss'
import champions from '@assets/images/ipl/CHAMPIONS.svg'
import Image from 'next/future/image'
import RR from '@assets/images/ipl/team/RR.png'
import DC from '@assets/images/ipl/team/DC.png'
import CSK from '@assets/images/ipl/team/CSK.png'
import MI from '@assets/images/ipl/team/MI.png'
import KKR from '@assets/images/ipl/team/KKR.png'
import GT from '@assets/images/ipl/team/GT.png'
import SRH from '@assets/images/ipl/team/SRH.png'
import TBA from '@assets/images/ipl/team/TBA.png'
import team11 from '@assets/images/ipl/team/2011.png'
import team14 from '@assets/images/ipl/team/2014.png'
import team15 from '@assets/images/ipl/team/2015.png'
import team17 from '@assets/images/ipl/team/2017.png'
import team18 from '@assets/images/ipl/team/2018.png'
import team19 from '@assets/images/ipl/team/2019.png'
import team20 from '@assets/images/ipl/team/2020.png'
import team21 from '@assets/images/ipl/team/2021.png'
import team23 from '@assets/images/ipl/team/2023.png'
import team24 from '@assets/images/ipl/team/2024.png'

const previousWinners = [
  { year: 2008, team: 'RR', img: RR },
  { year: 2009, team: 'DC', img: DC },
  { year: 2010, team: 'CSK', img: CSK },
  { year: 2011, team: 'CSK', img: team11 },
  { year: 2012, team: 'KKR', img: KKR },
  { year: 2013, team: 'MI', img: MI },
  { year: 2014, team: 'KKR', img: team14 },
  { year: 2015, team: 'MI', img: team15 },
  { year: 2016, team: 'SRH', img: SRH },
  { year: 2017, team: 'MI', img: team17 },
  { year: 2018, team: 'CSK', img: team18 },
  { year: 2019, team: 'MI', img: team19 },
  { year: 2020, team: 'MI', img: team20 },
  { year: 2021, team: 'CSK', img: team21 },
  { year: 2022, team: 'GT', img: GT },
  { year: 2023, team: 'CSK', img: team23 },
  { year: 2024, team: 'KKR', img: team24 },
  { year: 2025, team: '?', img: TBA }
]

const IPLPreviousWinners = () => {
  return (<>
    <div className='d-md-flex  flex-column d-none mt-4'>
      <h4 className='mt-0'>Previous Winners</h4>
      <div className={style.previousWinner}>
        <Image unoptimized={true} src={champions} alt='Champions' className='mb-4' />
        <div className={style.winnerLayout}>
          <span>INDIAN PREMIER LEAGUE</span>
        </div>
        <div className={style.grid}>
          {previousWinners.slice().reverse().map((winner) => {
            return <Image unoptimized={true} src={winner.img} alt={winner.team} key={winner.year} width={110} height={110} />
          })}
        </div>
      </div>
    </div>
    <div className='d-flex flex-column d-md-none'>
      <div className="widget-title  d-flex justify-content-between align-items-center">
        <h3 className="small-head d-flex align-items-center mb-0 mb-md-3">
          <span className='mt-2'>Previous Winners</span>
        </h3>
      </div>
      <div className={style.mwebPrevious}>
        <Image unoptimized={true} src={champions} alt='Champions' width={171} height={53} />
        <div className={style.winnerMweb}>
          <span>INDIAN PREMIER LEAGUE</span>
        </div>
        <div className={style.grids}>
          {previousWinners.slice().reverse().map((winner) => {
            return <Image unoptimized={true} src={winner.img} alt={winner.team} key={winner.year} width={95} height={95} />
          })}
        </div>
      </div>
    </div>
  </>
  )
}

export default IPLPreviousWinners
